export default [
  { id: 'Адмиралтейский', name: 'Адмиралтейский район' },
  { id: 'Василеостровский', name: 'Василеостровский район' },
  { id: 'Выборгский', name: 'Выборгский район' },
  { id: 'Калининский', name: 'Калининский район' },
  { id: 'Кировский', name: 'Кировский район' },
  { id: 'Колпинский', name: 'Колпинский район' },
  { id: 'Красногвардейский', name: 'Красногвардейский район' },
  { id: 'Красносельский', name: 'Красносельский район' },
  { id: 'Кронштадтcкий', name: 'Кронштадтcкий район' },
  { id: 'Курортный', name: 'Курортный район' },
  { id: 'Московский', name: 'Московский район' },
  { id: 'Невский', name: 'Невский район' },
  { id: 'Петроградский', name: 'Петроградский район' },
  { id: 'Петродворцовый', name: 'Петродворцовый район' },
  { id: 'Приморский', name: 'Приморский район' },
  { id: 'Пушкинский', name: 'Пушкинский район' },
  { id: 'Фрунзенский', name: 'Фрунзенский район' },
  { id: 'Центральный', name: 'Центральный район' },
  { id: '100', name: 'Не из Санкт-Петербурга' },
];
